import { useTranslation } from 'react-i18next';
import { UserStatus } from '../../../services/api';
import './Privacy.css';
import PersonalDataCard from './PersonalDataCard';
import ConsentTrackingCard from './ConsentTrackingCard';
import DataPortabilityCard from './DataPortabilityCard';
import TravelDataCard from './TravelDataCard';
import DangerZoneCard from './DangerZoneCard';

interface PrivacySectionProps {
    userStatus: UserStatus;
    onSettingsChange?: () => void;
}

export default function PrivacySection({ userStatus, onSettingsChange }: PrivacySectionProps) {
    const { t } = useTranslation();
    return (
        <div className="privacy-section-container">
            <div className="section-intro">
                <h2>{t('privacy.data_protection')}</h2>
                <p>{t('privacy.exercise_rights')}</p>
            </div>

            <div className="privacy-grid">
                <PersonalDataCard userStatus={userStatus} />
                <ConsentTrackingCard userStatus={userStatus} onSettingsChange={onSettingsChange} />
                <DataPortabilityCard />
                <TravelDataCard />
                <DangerZoneCard />
            </div>
        </div>
    );
}
